import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { clientApi } from '@/components/Client/api';
import { getClientInfo, setClient } from '@/components/Client/client.store';
import { WEBVIEW_SESSION_MARKER } from '@/components/Client/shared/webview/auth';
import { isInWebView } from '@/components/Client/shared/webview/env';
import { CLIENT_ROUTES } from '@/components/Shared/routes/routes';
import { getClientToken } from '@/services/user-hash';
import { useAppDispatch } from '@/store';

import { ClientModuleLoader } from '../../ui';

const AuthProvider: React.FC = () => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const protectedPathname = !window.location.pathname.includes(
        CLIENT_ROUTES.autoCreditCreate
      );
      let isSsoAuthorized = clientApi.isSsoAuthorized();
      if (!isSsoAuthorized && isInWebView() && protectedPathname) {
        isSsoAuthorized = await clientApi.ssoAuthorize();
      }

      const client = getClientToken();
      // Наличие client.iin обозначает, что пользователь авторизован в системе
      if (isSsoAuthorized && isInWebView()) {
        dispatch(setClient({ iin: WEBVIEW_SESSION_MARKER }));
      } else if (client?.accessToken) {
        dispatch(setClient({ iin: client.iin }));
      } else {
        dispatch(setClient(null));
      }
      if (client?.accessToken || isSsoAuthorized) {
        await dispatch(getClientInfo());
      }
      setIsLoading(false);
    })();
  }, []);

  if (isLoading) {
    return <ClientModuleLoader fullScreen />;
  }

  return <Outlet />;
};

export default AuthProvider;
